import React, { useEffect, useState } from 'react';
import { AuthContext } from './context';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { selectedProduct } from '../actions';
//import { IoPlay, IoPause, IoSkipBackwardOutline, IoSkipForward } from "@reacticons/ionicons";
import { FaClock, FaPhone, FaPlay, FaDollarSign } from "react-icons/fa";
//import { Alarm, Call, PlaySkipBackCircle, LogoBitcoin } from 'react-ionicons';
//import { PlaySkipBackCircle, Alarm, TelephoneFill, CurrencyExchange } from 'react-bootstrap-icons';



const ProductDetail = () => {
    
    const history = useHistory();
    const loginState = useSelector(state => state.currentLogin); //consolidated new Redux login state
    const { signOut } = React.useContext(AuthContext);
    const product = useSelector(state => state.selectedProduct.product);
    const {id, name, imageName, mapLink, phone, waitingTime, category, price, description} = product;
    const productId = useParams();
    const dispatch = useDispatch();
    const [axiosCount, setAxiosCount] = useState(0);


    useEffect(() => {
        //console.log('[*] {ProductDetail} Redux loginState -> [userid]: ', loginState.userid, '  [isLoggedIn]: ', loginState.isLoggedIn, '  [username]: ', loginState.username, '  [firstName]: ', loginState.firstName, '  [lastName]: ', loginState.lastName, '  [token]: ', loginState.token);
        const ac = new AbortController();

        const fetchProductDetail = async () => {
            //console.log('[*] Product Detail (loginState.token)', loginState.token);
            //console.log('[*] Product Detail (productId.id)', productId.id);
            console.log('[*] Product Detail (axiosCount)', axiosCount);
            await axios
            //.get(`/product/find/${productId.id}`, { headers: {Authorization: `${localStorage.getItem('token')}`} })  //this is fine...
            .get(`/product/find/${productId.id}`, { headers: {Authorization: loginState.token} })
            .then(response => {
                //console.log('[*] Product Detail (Redux state)', response.data);
                dispatch(selectedProduct(response.data));
                //console.log('ProductId Obj useParams(): ', productId);
            })
            .catch((err) => {
                //[Call to action] On first load sure fail as Redux state is not in yet, we cant logout user.  but how do we know if its a valid user on reload?
                // {To Improve} When axiosCount reaches 2 it redirects user to home page.
                setAxiosCount(axiosCount + 1);
                if (axiosCount >= 1){
                    console.log('❌ ProductDetail: ', err);
                    signOut(); //signout if we get an error to retrieve data... we can take action on different errors 401, 403, etc...
                    history.push("/");
                }
            });
        };

        if(productId && productId !== "") {
            fetchProductDetail(); 
        }

        return () => ac.abort(); // Abort both fetches on unmount, if we dont do this we will get error - perform react state update on unmounted component.

    }, [productId, dispatch, loginState, signOut, history, axiosCount]);  //on first run loginState.token is null it returns 401, when loginState.token updates axios is called again and loads page.

    const AddressMap = () =>{
        return (
            <div className="google-map-code">
              <iframe
                title = {id}
                src = {mapLink}
                //src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.801163243839!2d103.84781885141314!3d1.2937915621061198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x92e311597c4db868!2sNational%20Museum%20of%20Singapore!5e0!3m2!1sen!2ssg!4v1621188016529!5m2!1sen!2ssg" 
                width="400" 
                height="285" 
                frameBorder="0" 
                style={{ border:0 }} 
                allowFullScreen="" 
                aria-hidden="false" 
                tabIndex="0"
              />
            </div>
       );
     }

    return (
        <div className="container border" style={{ marginTop: 50 }}>
            <div className="row">
                <div className="col">
                    <div className="card-product-detail">
                        <div className="card-body">
                            <img className="img-big" src={imageName} alt="Product"></img>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card-product-detail">
                        <div className="card-body">
                            <h4 className="card-title"><Link to={`/`}><FaPlay/></Link> {name}</h4>
                            <div>
                                <div className="category-text">{category} </div><br />
                                <FaDollarSign/> ${price}<br />
                                <FaClock/> {waitingTime} Mins<br />
                                <FaPhone/>{phone} 
                            </div>
                            <br />
                            <div>
                                <p className="text-muted">{description}</p>
                            </div>
                            <AddressMap />
                            {/*<Link to={`/`} onClick={ ()=> signOut()} className="nav-link"><strong>Logout</strong></Link>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        /*
        <div className="container">
            <div className="row">
                <div className="col overflow-hidden flex-md-row mb-4 shadow-sm">
                    <div className="card">
                        <div className="card-horizontal">
                            <div className="img-square-wrapper">
                                <img className="img-big" src={imageName} alt="Card image cap"></img>
                            </div>

                            <div className="card-body">
                                <h4 className="card-title"><Link to={`/`}><FaPlay/></Link> {name}</h4>
                                <div>
                                    <div className="category-text">{category} </div><br />
                                    <FaDollarSign/> ${price}<br />
                                    <FaClock/> {waitingTime} Mins<br />
                                    <FaPhone/>{phone} 
                                </div>
                                <br />
                                <div>
                                    <p className="text-muted">{description}</p>
                                </div>
                                <AddressMap />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        */
    );
}
export default ProductDetail;